import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './QuickFilters.css';
import { getQuickFiltersIconByKey } from './getQuickFiltersIconByKey';
import { NewbuildingEntryPointExperiment } from '../../containers/NewbuildingEntryPointExperiment';
import { IQuickFiltersBlock } from '../../types/quickFilters';
import { useHighlighting } from '../../utils/highlightingProvider';

export interface IQuickFilters {
  filters: IQuickFiltersBlock[];
  trackClickQuickFilter(key: string): void;
  isNewbuildingEntryEnabled: boolean;
}

export const QuickFilters: React.FC<IQuickFilters> = ({
  filters,
  trackClickQuickFilter,
  isNewbuildingEntryEnabled,
}) => {
  const { highlightRef } = useHighlighting();

  return (
    <div className={styles['filters']} data-testid="QuickFilters">
      {filters.map((filter: IQuickFiltersBlock) => {
        const trackClick = () => trackClickQuickFilter(filter.key);

        const linkElement = (
          <a
            ref={
              filter.key === 'newbuilding'
                ? (highlightRef as React.MutableRefObject<HTMLAnchorElement | null>)
                : undefined
            }
            key={filter.key}
            href={filter.queryString}
            className={styles['filter']}
            onClick={filter.key === 'newbuilding' && isNewbuildingEntryEnabled ? undefined : trackClick}
          >
            <img className={styles['filter-icon']} src={getQuickFiltersIconByKey(filter.key)} />
            <UIText1>{filter.title}</UIText1>
          </a>
        );

        return filter.key === 'newbuilding' && isNewbuildingEntryEnabled ? (
          <NewbuildingEntryPointExperiment key={filter.key} trackClickQuickFilter={trackClick}>
            {linkElement}
          </NewbuildingEntryPointExperiment>
        ) : (
          linkElement
        );
      })}
    </div>
  );
};
